import { Cookies } from 'react-cookie';

const getVersionLabel = () => {
  const cookies = new Cookies();
  const versionCookie = cookies.get('version');
  switch (versionCookie) {
    case 'us':
      return 'US Version';
    case 'international':
      return 'International Version';
    default:
      return '';
  }
};

const getVersionCode = () => {
  const cookies = new Cookies();
  return cookies.get('version');
};

const VersionService = {
  getVersionLabel,
  getVersionCode,
};

export default VersionService;



// WEBPACK FOOTER //
// ./src/VersionService.js